/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-unused-vars */
import CustomLink from "@Components/CustomLink";
import styles from "./HeaderDesktop.module.scss";
import config from "@Config/index";
import Image from "@Components/Image";
import SearchModalMobile from "@Components/SearchModalMobile";
import ShortlistIcon from "@Icons/ShortlistIcon";
import LoginIcon from "@Icons/LoginIcon";
import HamburgurIcon from "@Icons/HamburgurIcon";
import UserIcon from "@Icons/UserIcon";
import HeadPhoneIcon from "@Icons/HeadPhoneIcon";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import DownloadApp from "./components/DownloadApp";
import React, { useEffect, useState } from "react";
import Portal from "@Components/Portal";
import Modal from "@Components/Modal";
import MenuDropdown from "@Components/MenuDropdown";
import Support from "./components/Support";
import LoginDispatcher from "@Components/Login/actions";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import LoginToContinue from "./components/LoginToContinue";
import { AppState } from "@Store/index";
import isInternalUser from "@Utils/isInternalUser";
import PropertyDetailsModal from "@Pages/PropertyPage/components/PropertyDetailsModal";
import ShareProperty from "@Pages/PropertyPage/components/ShareProperty";
import PropertyPageDispatcher from "@Pages/PropertyPage/data/actions";
import Chevron from "@Icons/Chevron";
import gtagEventEmitter, { gtagDuplicateEventEmitter } from "helpers/gtagEventEmitter";
import {
  COMPONENTS_CATEGORY,
  EVENT_LABEL,
  GROWTH_BOOK_FEATURE_FLAG_NAMES,
  AMBASSADOR_PAGE_STATIC_URL,
  SCHOLARSHIP_PAGE_STATIC_URL,
} from "constants/index";
import AppPromotionBannerDesktop from "@Components/AppPromotionBannerDesktop";
import WeChatQRBannerDesktop from "@Components/WeChatQRBannerDesktop";
import CookiePolicy from "@Components/CookiePolicy";
import City from "@Icons/City";
import Globe from "@Icons/Globe";
import useTranslationHook from "hooks/useTranslationHook";
import AgentViewTour from "./components/AgentViewTour";
import useWhitelabel from "hooks/useWhitelabel";
import formatValidOuterLink from "helpers/formatValidOuterLink";
import AmberSmall from "@Icons/AmberSmall";
import { getWhiteLabelHomeRedirectionURL } from "@Pages/WhitelabelHome/Desktop/helpers/WhiteLabelRedirectionHelper";
import ReferralBarForHeader from "@Components/ReferralBarForHeader/ReferralBarForHeader";
import { PAGE } from "constants/configConstants";
import getImagePath from "@Utils/getImagePath";
import LanguageSelectorModal from "@Components/LanguageSelectorModal/LanguageSelectorModal";
import useIsLanguage from "hooks/useIsLanguage";
import urlBuilder from "@Utils/urlBuilder";
import ProductsDropdown from "@Components/ProductsDropdown";
import Header from "..";
import BlueprintLogo from "@Icons/BlueprintLogo";
import AccommodationIcon from "@Icons/AccommodationIcon";
import EnvelopeIcon from "@Icons/EnvelopeIcon";
import MediaBlogIcon from "@Icons/MediaBlogIcon";
import NewsroomIcon from "@Icons/NewsroomIcon";
import BlogsIcon from "@Icons/BlogsIcon";
import { languagesForAmberUserWebsite } from "locales/langConfig/langConfig";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import useIsIframe from "hooks/useIsIframe";
import currencyData from "constants/currencyConstants";
import useCustomWindowOpen from "@Components/CustomWindowOpen";
import useCustomWindowLocation from "@Components/CustomWindowLocation";

const tabs = ({
  internalUser,
  transparentBg,
  isAmberPlusHeader,
  languageCode,
  support,
  shortlist,
  isWhitelabel,
  whitelabelColors,
  isDemoSubdomain,
  partner_uuid,
  isAmberPlusCategoryHeader,
  isBlogHeader,
  isNewsHeader,
  isMediaHeader,
  isPodcastHeader,
  isScholarshipPage,
  isExamsHeader,
  showLangSelector,
  shouldShowShortlist,
  userCurrencySymbol,
  t,
}: any) => {
  const isContentHeader = isBlogHeader || isNewsHeader || isExamsHeader;
  return [
    !isWhitelabel &&
      !internalUser &&
      !isAmberPlusCategoryHeader && {
        title: t("Download App"),
        key: "downloadApp",
        className: "tabletStyles",
        icon: (
          <Image
            dataTestId="Download-App-image"
            src={`${config.IMAGE_STATIC_URL}/images/App_Download_${
              transparentBg ? "White_Nav_bar_2" : "Black_Nav_bar"
            }.gif?w=80`}
            width={20}
            height={20}
          />
        ),
        modal: (parentPage: string) => <DownloadApp parentPage={parentPage} />,
      },
    (isContentHeader || isMediaHeader || isPodcastHeader || isScholarshipPage) && {
      title: t("Accommodation"),
      key: "accommodation",
      icon: <AccommodationIcon fill={transparentBg ? "#fff" : "#000"} width={16} height={16} />,
      href: "/",
    },
    isBlogHeader && {
      title: t("Newsroom"),
      key: "newsroom",
      icon: <NewsroomIcon />,
      href: "/news",
    },
    isNewsHeader && {
      title: t("Blogs"),
      key: "blogs",
      icon: <BlogsIcon />,
      href: "/blog",
    },
    isExamsHeader && {
      title: "Blog",
      key: "blog",
      icon: <BlogsIcon />,
      href: "/blog",
    },
    isScholarshipPage && {
      title: t("Blog"),
      key: "blog",
      icon: <BlogsIcon fill={transparentBg ? "#fff" : "#000"} />,
      href: "/blog",
    },
    isScholarshipPage && {
      title: t("Contact Us"),
      key: "contactUs",
      icon: <EnvelopeIcon fill={transparentBg ? "#fff" : "#000"} width={16} height={16} />,
      href: "/profile/support",
    },
    isMediaHeader && {
      title: t("Blog"),
      key: "blog",
      icon: <MediaBlogIcon fill={transparentBg ? "#fff" : "#000"} />,
      href: "/blog",
    },
    isMediaHeader && {
      title: t("Contact Us"),
      key: "contactUs",
      tabClass: "mediaOutline",
      icon: <EnvelopeIcon fill={transparentBg ? "#fff" : "#000"} width={16} height={16} />,
      href: "/profile/support",
    },
    isPodcastHeader && {
      title: "Blog",
      key: "blog",
      icon: <MediaBlogIcon fill={transparentBg ? "#fff" : "#000"} />,
      href: "/blog",
    },
    isPodcastHeader && {
      title: "Contact Us",
      key: "contactUs",
      tabClass: "mediaOutline",
      icon: <EnvelopeIcon fill={transparentBg ? "#fff" : "#000"} width={16} height={16} />,
      href: "/profile/support",
    },
    !isContentHeader &&
      !isMediaHeader &&
      !isPodcastHeader &&
      !isScholarshipPage &&
      !isWhitelabel && {
        title: (
          <>
            {support} <Chevron height="18" width="18" />
          </>
        ),
        key: "support",
        icon: (
          <HeadPhoneIcon
            fill={
              isWhitelabel
                ? `${whitelabelColors?.primary_text_color}`
                : transparentBg
                ? "#fff"
                : "#000"
            }
          />
        ),
        dropDown: <Support />,
      },
    shouldShowShortlist &&
      !isMediaHeader &&
      !isPodcastHeader && {
        title: shortlist,
        key: "shortlist",
        icon: (
          <ShortlistIcon
            fill={
              isWhitelabel
                ? `${whitelabelColors?.primary_text_color}`
                : transparentBg
                ? "#fff"
                : "#000"
            }
          />
        ),
        href: isDemoSubdomain
          ? `/profile/shortlist/?partner_id=${partner_uuid}`
          : "/profile/shortlist",
      },
    !isAmberPlusHeader &&
      !isWhitelabel &&
      showLangSelector &&
      !isContentHeader &&
      !isPodcastHeader &&
      !isScholarshipPage &&
      !config.IS_CHINA_APP && {
        title: `${languageCode}${userCurrencySymbol ? ` · ${userCurrencySymbol}` : ""}`,
        key: "languageSelector",
        icon: transparentBg ? <Globe fill="#ffffff" /> : <Globe fill="#1e1e1e" />,
      },
    internalUser &&
      !isAmberPlusHeader && {
        title: (
          <>
            Products <Chevron height="18" width="18" />
          </>
        ),
        key: "products",
        dropDown: <ProductsDropdown />,
      },
    isAmberPlusHeader && {
      title: "Accommodation",
      key: "accommodation",
      icon: <City />,
      href: "/",
    },
  ].filter(Boolean);
};

const outlineTabs = ({
  isUserLoggedIn,
  transparentBg,
  login,
  isWhitelabel,
  whitelabelColors,
  isReferralPage,
  isAmberPlusHeader,
}: any) =>
  [
    !isUserLoggedIn && {
      title: login,
      key: "login",
      icon: (
        <LoginIcon
          fill={
            isWhitelabel
              ? `${whitelabelColors?.primary_text_color}`
              : transparentBg
              ? "#fff"
              : "#000"
          }
        />
      ),
    },
    {
      title: (
        <HamburgurIcon
          fill={
            isWhitelabel
              ? `${whitelabelColors?.primary_text_color}`
              : transparentBg
              ? "#fff"
              : "#111928"
          }
          width="16"
        />
      ),
      key: "menu",
      icon: (
        <i className={styles.user}>
          <UserIcon size={24} {...(isWhitelabel && { fill: "#6B7280" })} />
        </i>
      ),
      dropDown: (
        <LoginToContinue isReferralPage={isReferralPage} isAmberPlusHeader={isAmberPlusHeader} />
      ),
    },
  ].filter(Boolean);

const HeaderDesktop = ({
  parentPage = "",
  transparentBg = false,
  hideSearchBar = false,
  hideAppBanner = false,
  isAbsolute = false,
  isFixed = false,
  showCookiePolicy = false,
  isAmberPlusHeader = false,
  isAmberPlusCategoryHeader = false,
  isReferralPage = false,
  isBlogHeader = false,
  isNewsHeader = false,
  isMediaHeader = false,
  isPodcastHeader = false,
  isExamsHeader = false,
  showSearchButtonOnScrollBar = false,
  showLangSelector = true,
  isAmbassadorHeader = false,
  isScholarshipPage = false,
  isCareerPage = false,
}: any) => {
  const customWindowOpen = useCustomWindowOpen();
  const customWindowLocation = useCustomWindowLocation();
  const {
    isWhitelabel,
    whitelabelConfig,
    whitelabelColors,
    isDemoSubdomain,
    partner_uuid,
    isUniversityPartner,
    partnerType,
    isPoweredByAmberEnabledForWhitelabelFooter,
    shouldHidePoweredByAmber,
  } = useWhitelabel();
  const { isIframe } = useIsIframe();

  const [showModal, setShowModal] = useState("");
  const { isUserLoggedIn, userData, showShare, inventoryUrl, userCurrency, canonicalName } =
    useSelector(
      ({ propertyPageData, appData }: AppState) => ({
        isUserLoggedIn: appData.isUserLoggedIn,
        userData: appData.userData,
        showShare: propertyPageData.showShareModal,
        inventoryUrl: propertyPageData.data?.inventoryUrl,
        userCurrency: appData.userCurrency,
        canonicalName: propertyPageData.data?.canonical_name,
      }),
      shallowEqual,
    );
  const shortlistCount = userData?.data?.inventories_shortlists_ids?.length;
  const internalUser = isInternalUser(userData);
  const dispatch = useDispatch();
  const propertyPageDispatcher = new PropertyPageDispatcher(dispatch);
  const isHomePage = parentPage === PAGE.HOME;
  const isContentHeader = isBlogHeader || isNewsHeader || isExamsHeader;
  const isCurrencyFeatureEnabled = useFeatureIsOn(
    GROWTH_BOOK_FEATURE_FLAG_NAMES.ONE_PLATFORM_CURRENCY_CHANGES,
  );
  const shouldShowShortlist =
    !isContentHeader &&
    !isCareerPage &&
    !isAmbassadorHeader &&
    (isWhitelabel || (!isAmberPlusHeader && !showLangSelector));
  // for china language modal
  const userLanguage = useIsLanguage();
  const userCurrencySymbol =
    currencyData.find(
      (it) => it.standard_name?.toLocaleLowerCase() === userCurrency?.toLocaleLowerCase(),
    )?.symbol || "";

  const handleOnClick = (it: any) => {
    let action = "";
    if (it.key == "shortlist") {
      action = "shortlist_clicked";
      gtagEventEmitter({
        action,
        category: COMPONENTS_CATEGORY.TOP_NAV,
        new_user_website: true,
      });
    } else if (it.key == "support") {
      action = EVENT_LABEL.SUPPORT_CLICKED;
      gtagEventEmitter({
        action,
        category: COMPONENTS_CATEGORY.TOP_NAV,
        new_user_website: true,
      });
    } else if (it.key == "products") {
      action = "products_clicked";
      gtagEventEmitter({
        action,
        category: COMPONENTS_CATEGORY.TOP_NAV,
        new_user_website: true,
      });
    } else if (
      it.key == "accommodation" ||
      it.key == "newsroom" ||
      it.key == "blogs" ||
      it.key === "blog" ||
      it.key === "contactUs"
    ) {
      action = `${it.key}_clicked`;
      gtagEventEmitter({
        action,
        category: COMPONENTS_CATEGORY.TOP_NAV,
        new_user_website: true,
      });
    }

    if (it.key === "languageSelector") {
      setShowModal("languageSelector");
      action = "language_currency_selector_clicked";
      gtagEventEmitter({
        action,
        category: COMPONENTS_CATEGORY.TOP_NAV,
        new_user_website: true,
      });
      return;
    }

    if (it.modal) {
      setShowModal(it.key);
    }
    if (it.key === "agent_view") {
      const currentLocation = `${window?.location?.pathname}/agent-view`;
      const urlParams = new URLSearchParams(window.location.search);
      const whitelabelv2 = urlParams.get("whitelabelv2");
      const utmSource = urlParams.get("utm_source");

      let finalUrl = currentLocation;
      if (whitelabelv2 && utmSource) {
        finalUrl = `${currentLocation}?whitelabelv2=${whitelabelv2}&utm_source=${utmSource}`;
      }

      customWindowOpen({ url: finalUrl, target: "_self" });
    }
    if (it.href) {
      // For blog/media/news header navigation items, use internal navigation
      if (
        it.key === "accommodation" ||
        it.key === "newsroom" ||
        it.key === "blogs" ||
        it.key === "blog" ||
        it.key === "contactUs"
      ) {
        customWindowLocation({ url: it.href });
      } else {
        customWindowOpen({ url: it.href, target: "_blank", isExternal: true });
      }
    }
  };

  const handleHideModal = () => {
    setShowModal("");
  };

  const renderTabItem = (it: any) => (
    <div
      data-testid={it.title}
      className={formatClassNames(
        styles.tabItem,
        it.tabClass && styles[it.tabClass],
        transparentBg && styles.tabItemTbg,
        it.className === "tabletStyles" ? styles.removeTab : "",
      )}
      onClick={() => handleOnClick(it)}
      role="button"
      aria-label={it.title}
      tabIndex={0}
      onKeyDown={(event) => {
        if (event.key === "Enter") {
          handleOnClick(it);
        }
      }}
    >
      {it.icon}
      {it.title}
      {it.key === "shortlist" && shortlistCount ? (
        <span className={styles.shortlist}>{shortlistCount}</span>
      ) : (
        ""
      )}
    </div>
  );

  const handleLoginClick = () => {
    const loginDispatcher = new LoginDispatcher(dispatch);
    loginDispatcher.showLoginModal({});
    gtagEventEmitter({
      action: EVENT_LABEL.LOGIN_CLICKED,
      category: COMPONENTS_CATEGORY.TOP_NAV,
      new_user_website: true,
    });
  };

  const handleOnOutlineTabClick = (it: any) => {
    if (it.key == "menu") {
      gtagEventEmitter({
        action: EVENT_LABEL.MENU_CLICKED,
        category: COMPONENTS_CATEGORY.TOP_NAV,
        new_user_website: true,
      });
    }
    if (it.key === "login") {
      handleLoginClick();
    }
    if (it.href) {
      customWindowOpen({ url: it.href, target: "_self" });
    }
  };

  const blogAssetBase = config.IS_CHINA_APP
    ? config.CHINA_STATIC_ASSETS_URL
    : config.BLOG_ASSET_URL;

  const darkHeaderImgSrc = isNewsHeader
    ? `${config.BLOG_ASSET_URL}/620e4101b2ce125835bff0bb/amber-news-logo.svg`
    : isBlogHeader
    ? `${blogAssetBase}/620e4101b2ce125835bff0bb/amber-blog-logo.svg`
    : config.IS_CHINA_APP
    ? `${config.IMAGE_STATIC_URL}/images/logo/amber-china-logo-dark.svg?auto=format&q=10&w=120&h=24`
    : `${config.IMAGE_STATIC_ASSETS_COMPONENTS_PATH}/Header/assets/amber-logo-dark.svg`;

  const lightHeaderImgSrc = isNewsHeader
    ? `${config.BLOG_ASSET_URL}/620e4101b2ce125835bff0bb/amber-news-logo.svg`
    : isBlogHeader
    ? `${blogAssetBase}/620e4101b2ce125835bff0bb/amber-blog-logo.svg`
    : config.IS_CHINA_APP
    ? `${config.IMAGE_STATIC_URL}/images/logo/amber-china-logo-light.svg?auto=format&q=10&w=120&h=24`
    : `${config.IMAGE_STATIC_URL}/images/logo/amber-logo-light.svg`;

  const { t } = useTranslationHook();

  const [inventoryShareURL, setInventoryShareURL] = useState(inventoryUrl);

  const poweredByAmberRedirectionURL = isWhitelabel
    ? urlBuilder(config.WEB_SERVICE_URL, {
        params: {
          utm_source: partner_uuid,
          utm_medium: partnerType,
          utm_campaign: "partner",
          partner_source: partner_uuid,
        },
      })
    : `${config.WEB_SERVICE_URL}`;

  useEffect(() => {
    if (typeof window !== "undefined" && isWhitelabel) {
      setInventoryShareURL(window.location.href);
    }
  }, [isWhitelabel]);

  useEffect(() => {
    if (config.IS_WHITELABEL_APP) {
      gtagDuplicateEventEmitter({ action: "pageview_event", category: "" });
    }
  }, []);

  return (
    <>
      {!transparentBg && (
        <Header
          isBlogHeader={isBlogHeader}
          isNewsHeader={isNewsHeader}
          isExamsHeader={isExamsHeader}
          isAmbassadorHeader={isAmbassadorHeader}
          isScholarshipPage={isScholarshipPage}
          isCareerPage={isCareerPage}
        />
      )}
      <div
        className={formatClassNames(
          styles.container,
          transparentBg && styles.transparentBg,
          isAbsolute && styles.transparentBgForAbsoluteStyling,
          isFixed && styles.transparentBgForFixedStyling,
          isWhitelabel && styles.whitelabelHeaderContainer,
          isScholarshipPage && styles.scholarshipHeaderDesktop,
          isCareerPage && styles.careerHeaderDesktop,
          isMediaHeader && styles.mediaHeaderDesktop,
          isPodcastHeader && styles.mediaHeaderDesktop,
        )}
        id="header"
      >
        {!isWhitelabel && !config.IS_CHINA_APP && !hideAppBanner && (
          <AppPromotionBannerDesktop parentPage={parentPage} />
        )}
        {config.IS_CHINA_APP && <WeChatQRBannerDesktop />}

        <div
          className={
            parentPage === PAGE.HOME
              ? styles.homepageWarpper
              : parentPage === PAGE.INVENTORY
              ? styles.ppwarpper
              : styles.warpper
          }
        >
          <div className={styles.leftSection}>
            {isWhitelabel ? (
              <div className={styles.whitelabelLogoSection}>
                {!whitelabelConfig?.logo ? (
                  <div className={styles.logoPlaceholder} />
                ) : (
                  <CustomLink
                    to={
                      !isHomePage
                        ? getWhiteLabelHomeRedirectionURL(isDemoSubdomain, partner_uuid)
                        : whitelabelConfig?.redirect_url
                        ? formatValidOuterLink(whitelabelConfig?.redirect_url)
                        : ""
                    }
                    target={isHomePage ? "_blank" : "_self"}
                    rel="noopener"
                    redirect={Boolean(isHomePage && whitelabelConfig?.redirect_url)}
                    stopLink={Boolean(isHomePage && !whitelabelConfig?.redirect_url)}
                  >
                    <Image
                      src={getImagePath(whitelabelConfig?.logo || "")}
                      isNotLazy
                      height={40}
                      width="auto"
                      alt={whitelabelConfig?.domain?.title || ""}
                      isWhitelabelIframeImage
                    />
                  </CustomLink>
                )}
                {whitelabelConfig?.page_title ? (
                  <>
                    <span className={styles.separator} />
                    <CustomLink
                      to={getWhiteLabelHomeRedirectionURL(isDemoSubdomain, partner_uuid)}
                      className={styles.link}
                    >
                      {whitelabelConfig?.page_title}
                    </CustomLink>
                  </>
                ) : (
                  <div className={styles.shimmerDiv} />
                )}
              </div>
            ) : (
              <>
                {!isAmberPlusHeader ? (
                  <CustomLink
                    to={
                      isNewsHeader
                        ? "/news"
                        : isBlogHeader
                        ? "/blog"
                        : isAmbassadorHeader
                        ? "/ambassador"
                        : isScholarshipPage
                        ? "/scholarship"
                        : isPodcastHeader
                        ? "/podcast"
                        : "/"
                    }
                    aria-label="home"
                    redirect={isContentHeader}
                    onClick={(e: React.MouseEvent) => {
                      if (isAmbassadorHeader || isScholarshipPage || isPodcastHeader) {
                        e.preventDefault();
                        window.location.reload();
                      }
                    }}
                  >
                    {isAmbassadorHeader ? (
                      <Image
                        dataTestId="Ambassador-logo"
                        src={
                          transparentBg
                            ? `${AMBASSADOR_PAGE_STATIC_URL}/ambassador_light_logo.png`
                            : `${AMBASSADOR_PAGE_STATIC_URL}/ambassador_dark_logo.png`
                        }
                        isNotLazy
                        height={24}
                        width={337.6}
                        alt="ambassador-logo"
                        onClick={() => {
                          gtagEventEmitter({
                            action: "clicked_ambassador_logo",
                            category: "",
                          });
                        }}
                      />
                    ) : isScholarshipPage ? (
                      <Image
                        dataTestId="Scholarship-logo"
                        src={
                          transparentBg
                            ? `${SCHOLARSHIP_PAGE_STATIC_URL}/scholarship_logo_light.svg`
                            : `${SCHOLARSHIP_PAGE_STATIC_URL}/scholarship_logo_dark.svg`
                        }
                        isNotLazy
                        height={24}
                        width={245}
                        alt="scholarship-logo"
                        onClick={() => {
                          gtagEventEmitter({
                            action: "clicked_scholarship_logo",
                            category: "",
                          });
                        }}
                      />
                    ) : isPodcastHeader ? (
                      <BlueprintLogo color={transparentBg ? "white" : "#111928"} />
                    ) : (
                      <div className={isBlogHeader ? styles.contentHeaderLogo : ""}>
                        <Image
                          dataTestId="Amber-logo"
                          src={transparentBg ? lightHeaderImgSrc : darkHeaderImgSrc}
                          isNotLazy
                          height={isContentHeader ? 24 : config.IS_CHINA_APP ? 48 : 24}
                          width={
                            isBlogHeader
                              ? "150"
                              : isContentHeader
                              ? "200"
                              : config.IS_CHINA_APP
                              ? 148
                              : 100
                          }
                          alt={
                            isNewsHeader
                              ? "amber-news-logo"
                              : isBlogHeader
                              ? "amber-blog-logo"
                              : "amber-logo-dark"
                          }
                          onClick={() => {
                            gtagEventEmitter({
                              action: isNewsHeader
                                ? "clicked_news_logo"
                                : isBlogHeader
                                ? "clicked_blog_logo"
                                : "clicked_amber",
                              category: "",
                            });
                          }}
                        />
                      </div>
                    )}
                  </CustomLink>
                ) : (
                  <CustomLink to="/plus" redirect aria-label="amber-plus-home">
                    <Image
                      src={`${config.IMAGE_STATIC_URL}/images/amber-plus-logo.svg?auto=format`}
                      isNotLazy
                      height={24}
                      width={106}
                      alt="amber-plus-logo"
                      onClick={() => {
                        gtagEventEmitter({ action: "clicked_amber_plus", category: "" });
                      }}
                    />
                  </CustomLink>
                )}
              </>
            )}

            {(!isWhitelabel || (isWhitelabel && !isUniversityPartner)) &&
              !hideSearchBar &&
              !isAmbassadorHeader &&
              !isScholarshipPage &&
              !isCareerPage &&
              !(isWhitelabel && isIframe) && (
                <div
                  className={config.IS_CHINA_APP ? styles.searchWrapChinaApp : styles.searchWrap}
                >
                  <SearchModalMobile
                    isDesktop
                    isBlogSearch={isBlogHeader}
                    isNewsSearch={isNewsHeader}
                    isExamsSearch={isExamsHeader}
                  />
                </div>
              )}
          </div>
          <div className={styles.rightSection}>
            {!(isWhitelabel && isIframe) && (
              <>
                {tabs({
                  internalUser,
                  transparentBg,
                  isAmberPlusHeader,
                  languageText: t("home.herosection.header.language"),
                  languageCode:
                    languagesForAmberUserWebsite.find((lang) => lang.code === userLanguage)
                      ?.shortDisplayText || "En",
                  support: t("home.herosection.header.support"),
                  shortlist: t("home.herosection.header.shortlist"),
                  isWhitelabel,
                  whitelabelColors,
                  isDemoSubdomain,
                  partner_uuid,
                  isAmberPlusCategoryHeader,
                  isBlogHeader,
                  isNewsHeader,
                  isMediaHeader,
                  isPodcastHeader,
                  isExamsHeader,
                  isScholarshipPage,
                  showLangSelector,
                  shouldShowShortlist,
                  isReferralPage,
                  userCurrencySymbol,
                  t,
                }).map((it) => (
                  <React.Fragment key={it.key}>
                    {!it.dropDown && renderTabItem(it)}
                    {it.modal && showModal === it.key && !config.IS_CHINA_APP && (
                      <Portal>
                        <Modal size="fitContent" align="center" hideModal={handleHideModal}>
                          {it.modal(parentPage)}
                        </Modal>
                      </Portal>
                    )}
                    {it.modal &&
                      showModal === it.key &&
                      config.IS_CHINA_APP &&
                      it.key === "downloadApp" && (
                        <Portal>
                          <Modal size="fitContent" align="center" hideModal={handleHideModal}>
                            {it.modal(parentPage)}
                          </Modal>
                        </Portal>
                      )}
                    {it.modal &&
                      showModal === it.key &&
                      config.IS_CHINA_APP &&
                      it.key !== "downloadApp" && (
                        <div className={styles.chinaAppBannerDropdown}>
                          <div
                            className={styles.chinaAppBannerBackdrop}
                            onClick={handleHideModal}
                            role="none"
                          />
                          <div className={styles.chinaAppBannerContent}>{it.modal(parentPage)}</div>
                        </div>
                      )}
                    {it.key === "languageSelector" && showModal === "languageSelector" && (
                      <Portal>
                        <Modal size="fitContent" align="center" hideModal={handleHideModal}>
                          <LanguageSelectorModal
                            onClose={handleHideModal}
                            isCurrencyFeatureEnabled={isCurrencyFeatureEnabled}
                          />
                        </Modal>
                      </Portal>
                    )}
                    {it.dropDown && (
                      <MenuDropdown
                        direction="left"
                        menu={it.dropDown}
                        target={renderTabItem(it)}
                        dataTestId="topnavbar-support-button"
                      />
                    )}
                  </React.Fragment>
                ))}
                {!isMediaHeader && !isPodcastHeader && !isScholarshipPage && (
                  <div className={styles.outlineTabsWrap}>
                    {outlineTabs({
                      isUserLoggedIn,
                      transparentBg,
                      login: t("home.herosection.header.login"),
                      isWhitelabel,
                      whitelabelColors,
                      isReferralPage,
                      isAmberPlusHeader,
                    }).map((it: any, key) => (
                      <React.Fragment key={key}>
                        {!it.dropDown && (
                          <div
                            className={formatClassNames(
                              styles.tabItem,
                              styles.outline,
                              transparentBg && styles.tabItemTbg,
                            )}
                            key={key}
                            role="button"
                            onClick={() => handleOnOutlineTabClick(it)}
                            data-testid={`topnavbar-${it.title}`}
                            tabIndex={0}
                            onKeyDown={(event) => {
                              if (event.key === "Enter") {
                                handleOnOutlineTabClick(it);
                              }
                            }}
                          >
                            {it.icon}
                            {it.title}
                          </div>
                        )}
                        {it.dropDown && (
                          <MenuDropdown
                            menu={it.dropDown}
                            target={
                              <div
                                className={formatClassNames(styles.tabItem, styles.outline)}
                                key={key}
                                onClick={() => handleOnOutlineTabClick(it)}
                                data-testid="topnavbar-hamburger-menu"
                                role="button"
                                tabIndex={0}
                                onKeyDown={(event) => {
                                  if (event.key === "Enter") {
                                    handleOnOutlineTabClick(it);
                                  }
                                }}
                              >
                                {isUserLoggedIn && userData?.data?.profile_image_url ? (
                                  <Image
                                    className={styles.userImage}
                                    src={userData?.data?.profile_image_url}
                                    alt="userprofile"
                                    width="24"
                                    height="24"
                                  />
                                ) : (
                                  <>{it.icon}</>
                                )}

                                {it.title}
                              </div>
                            }
                            direction="left"
                          />
                        )}
                      </React.Fragment>
                    ))}
                  </div>
                )}
              </>
            )}

            {isWhitelabel &&
              !isPoweredByAmberEnabledForWhitelabelFooter &&
              !shouldHidePoweredByAmber && (
                <>
                  {!isIframe && <span className={styles.rightSeparator} />}
                  <CustomLink
                    href={poweredByAmberRedirectionURL}
                    className={styles.poweredByAmber}
                    target="_blank"
                    rel="noopener"
                    isExternal
                    stopLink
                  >
                    <div className={styles.poweredByText}>Powered by</div>
                    <AmberSmall fill={whitelabelColors?.primary_text_color} />
                  </CustomLink>
                </>
              )}
          </div>
        </div>
        {showShare && (
          <Portal rootId="forPortal">
            <PropertyDetailsModal
              header={t("propertypage.headerdesktop.shareproperty")}
              hidePropertyModal={() => propertyPageDispatcher.showShareModal(false)}
              isDesktop
              removeFooter
            >
              <ShareProperty
                isDesktop
                inventoryUrl={inventoryShareURL}
                canonicalName={canonicalName}
              />
            </PropertyDetailsModal>
          </Portal>
        )}
        {showCookiePolicy && <CookiePolicy />}
        {isReferralPage && showSearchButtonOnScrollBar && <ReferralBarForHeader />}
        {!isWhitelabel && <AgentViewTour internalUser={internalUser} parentPageName={parentPage} />}
      </div>
    </>
  );
};

export default HeaderDesktop;
